'use strict';

import Vue from 'vue/dist/vue.common.js';

// Servcies
import EventsService from '../services/events';

// vuex
import store from '../vuex/store';

let EventListing = Vue.extend({
  store,

  data () {
    return {
      cityFilter: null,
      typeFilter: null,
      results: true,
      pageSize: 10,
      resultCount: 0,
      totalPages: 1,
      currentPage: 1,
      after: '',
      before: '',
      hasNextPage: false,
      hasPrevPage: false,
      events: [],
      initialLoad: true,
    };
  },

  mounted() {
    this.fetchEvents();
  },
  
  methods: {
  	scrollToTop: function() {    	
    },

    updateCity(event) {
      this.cityFilter = event.target.value;
      this.resetList();
      this.fetchEvents();
    },

    updateType(event) {
      this.typeFilter = event.target.value;
      this.resetList();
      this.fetchEvents();
    },

    resetList() {
      this.currentPage = 1;
      this.after = '';
      this.before = '';
      this.hasNextPage = false;
      this.hasPrevPage = false;
    },

    nextPage() {
      this.currentPage = this.currentPage + 1  
      this.fetchEvents();
    },

    prevPage() {
      this.currentPage = this.currentPage - 1
      this.fetchPrevEvents();
    },

    setButtons() {
      // We can't rely on the pageInfo.hasNextPage and .hasPreviousPage 
      // when moving both forward and backward (https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo.Fields), 
      // so we have to calculate this ourselves
      if (this.currentPage > 1) {
        this.hasPrevPage = true
      } else {
        this.hasPrevPage = false
      }

      if (this.currentPage < this.totalPages) {
        this.hasNextPage = true
      } else {
        this.hasNextPage = false
      }

      if (!this.initialLoad) {
        $(".EventListing")[0].scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }

      this.initialLoad = false;
    },

    // Fetch events with the current city and type filters
    fetchEvents() {
      EventsService.fetchNext(
      this.typeFilter, 
      this.cityFilter,
      this.pageSize,
      this.after,
      ).then(response => {
        this.events = response.data.eventsConnection.edges
        this.resultCount = response.data.eventsConnection.totalCount
        this.totalPages = Math.ceil(this.resultCount / this.pageSize)
        this.before = response.data.eventsConnection.pageInfo.startCursor
        this.after = response.data.eventsConnection.pageInfo.endCursor

        if (this.events.length) {
          this.results = true
        } else {
          this.results = false
        }
        this.setButtons();
      });
    },

    // Fetch events from the previous page
    fetchPrevEvents() {
      EventsService.fetchPrev(
      this.typeFilter, 
      this.cityFilter,
      this.pageSize,
      this.before,
      ).then(response => {
        this.events = response.data.eventsConnection.edges
        this.before = response.data.eventsConnection.pageInfo.startCursor
        this.after = response.data.eventsConnection.pageInfo.endCursor

        this.setButtons();
      });
    }
  }
});

export default EventListing;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/event-listing.js